export const convertValueToPixels = (value?: any) => {
  if (value === undefined || value === null) return '0px';
  if (typeof value === 'number') return value + 'px';
  const numericValues = new RegExp(/[^0-9.]/g);
  return value && value.endsWith('px') ? value : value.replace(numericValues, '') + 'px';
};
